import { useState } from "react";
import styles from "./meeting.module.scss";

export default function EndJitsiMetting() {
  const [input, setInput] = useState("");
  return (
    <div className={styles.endJitsiMeeting}>
        Thank you for attending the meeting
    </div>
  );
}
